import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";
class SubTabPaketPenjualanContent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        pagination: {
          page: 1,
          limit: 5,
        },
      };
    }


    handleChangePage = (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: tableState.page + 1,
        },
      }));
    };

    handleRowsPerPage = (tableState) => {
      this.setState((prevValue) => ({
        ...prevValue,
        pagination: {
          ...prevValue.pagination,
          page: 1,
          limit: tableState.rowsPerPage,
        },
      }));
    };

    resetPagination = () => this.setState({pagination:{limit: 5, page: 1}})
    
    render() {
        const {activeTab} = this.props;
        return (
            <>
                <Tabs 
                  onSelect={(index) => {
                    this.resetPagination();
                    this.props.handleTabChange(this.props.tabList[index]);
                  }}
                >
                    <TabList>
                        {this.props.tabList.map((tab, _) => (
                            <Tab id={`button_navigate_${tab}`}>{tab.label}</Tab>
                        ))}
                    </TabList>
                    {this.props.tabList.map((tab, index) => (
                        <TabPanel>
                            <SimpleDataTable
                                id={`table_data_${tab.label}`}
                                key={`${index}-${this.props.data?.dataPackage?.dataTable?.[activeTab?.value]?.length}-${this.state.pagination.page}`}
                                data={this.props.data?.dataPackage?.dataTable?.[activeTab?.value]}
                                columns={this.props.state.tableColumns}
                                toCount={this.props.data?.dataPackage?.dataTable?.[activeTab?.value]?.length}
                                rowsPerPage={this.state.pagination.limit}
                                page={this.state.pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />
                        </TabPanel>
                    ))}
                </Tabs>
            </>
        )
    }
}

export default SubTabPaketPenjualanContent ;